import { Injectable } from '@angular/core';

import { LookupsService, LookupType } from 'common';

@Injectable()
export class SalutationResolver  {
  constructor(private lookupsService: LookupsService) { }

  resolve() {
    return this.lookupsService.getListByType(LookupType.salutation).toPromise();
  }
}
